import { TablePagination } from '@mui/material';
import { ChangeEvent as ReactChangeEvent, MouseEvent as ReactMouseEvent, useCallback } from 'react';
import { TableInstance } from 'react-table';
import { NameChangeReviewGridItem } from 'shared/types';

interface NameChangeReviewTablePaginationProps {
  instance: TableInstance<NameChangeReviewGridItem>;
  totalCount: number;
}
export function NameChangeReviewTablePagination({ instance, totalCount }: NameChangeReviewTablePaginationProps) {
  const {
    state: { pageIndex, pageSize },
    gotoPage,
    setPageSize,
  } = instance;
  const handlePageChange = useCallback(
    (_: ReactMouseEvent<HTMLButtonElement, MouseEvent> | null, page: number) => {
      gotoPage(page);
    },
    [gotoPage]
  );

  const handleRowsPerPageChange = useCallback(
    (event: ReactChangeEvent<HTMLInputElement>) => {
      setPageSize(Number(event.target.value));
      gotoPage(0);
    },
    [setPageSize, gotoPage]
  );

  return (
    <TablePagination
      component='div'
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      page={pageIndex}
      rowsPerPageOptions={[15, 25, 50, 100]}
      count={totalCount}
      rowsPerPage={pageSize}
    />
  );
}
